import React from "react";
import PlanosRestantes from "./EstabelecimentoPlanos/PlanosRestantes";
import PlanosIranduba from "./EstabelecimentoPlanos/PlanosIranduba";

const Planos = () => {
    const isIranduba = localStorage.getItem("entidade_id") === "33";

    return <>{isIranduba ? <PlanosIranduba /> : <PlanosRestantes />}</>;
};

export default Planos;
